// App global errors
import { make } from 'vuex-pathify'

// Store states
const state = {
  loading: 0
}

// Store custom getters
const customGetters = {
  isLoading() {
    return state.loading > 0
  }

  // isLoaded: (state) => (model) => {
  //   let modelState = state.model[model]

  //   if (typeof modelState === "undefined") {
  //     return false
  //   }

  //   return !!modelState.loaded;
  // },

  // isLoadFailed: (state) => (model) => {
  //   let modelState = state.model[model]

  //   if (typeof modelState === "undefined") {
  //     return false
  //   }

  //   return !!modelState.loadFailed;
  // },
}

// // Store custom actions
// const customActions = {
//   startLoading({ commit }, model) {
//     var modelsCopy = { ...state.model };
//     modelsCopy[model] = true;
//     commit("SET_MODEL", modelsCopy);
//     // commit("START_LOADING", modelsCopy);  // called in axios interceptors
//   },
//   finishLoading({ commit }, model) {
//     var modelsCopy = { ...state.model };
//     modelsCopy[model] = false;
//     commit("SET_MODEL", modelsCopy);
//     // commit("FINISH_LOADING", modelsCopy);  // called in axios interceptors
//   },
// };

// Store custom mutations
const customMutations = {
  START_LOADING: (state) => state.loading++,
  FINISH_LOADING: (state) => state.loading--
}

// ---------------------------------------------
// Create store
// make all mutations and getters
const mutations = {
  ...make.mutations(state),
  ...customMutations
}
const getters = {
  ...make.getters(state),
  ...customGetters
}
const actions = {
  ...make.actions(state)
  // ...customActions,
}

export default {
  namespaced: true, // add this if in module
  state,
  mutations,
  actions,
  getters
}
